// extracted by mini-css-extract-plugin
export default {"latestEvent":"LatestEvent_latestEvent__nfZg9","latestEvent__title":"LatestEvent_latestEvent__title__OAMWK","latestEvent__text":"LatestEvent_latestEvent__text__Z5+Wn"};